import React, { useEffect, useMemo } from "react";
import "./marketplace.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Card, Table, message, Popover, Select } from "antd";
import { useState } from "react";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import moment from "moment";
import OtherPageHeader from "../../../components/OtherHeader";
import {
  amountFormat,
  getAmountFilterType,
  getYearFilterType,
  obj2url,
} from "../../../utils";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import RoleSwitch from "../../Helper/RoleSwitch";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import policyCenterImage from "../../../assets/policy_center.png";
// import policyCenterImage from "";
import CompleteProfileModel from "../../../components/Model/CompleteProfileMode";
import { insurerListController } from "../../Helper/provider";
export default function PolicyCenter() {
  const navigate = useNavigate();
  var [loading, setLoading] = useState(true);
  var [policies, setPolicies] = useState([]);
  var [userMeData, setUserStatus] = useState("PENDING");
  var [userRoles, setUserRoles] = useState([]);
  var [applyServiceUrl, setApplyServiceUrl] = useState("");
  const [partnerCodeModal, setPartnerCodeModal] = useState(false);
  var [dataSource, setDataSource] = useState([]);
  const [active, setActive] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [insurer, setInsurer] = useState([]);
  const [recommendPolicies, setRecommendPolicies] = useState();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const portfolioId = searchParams.get("portfolioId") ?? "";
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [filterData, setFilterData] = useState({
    minTenure: null,
    maxTenure: null,
  });
  const updateFilter = (data) => {
    var old = filterData;
    old = { ...old, ...data };
    setFilterData(old);
    console.log(data);
    getMarketPlaceData(0, old);
  };
  const investNowFunction = (data) => {
    if (
      userMeData.status === "NOT_UPDATED" ||
      userMeData.status === "REJECTED"
    ) {
      navigate("/investorKyc");
    } else if (userMeData.status === "APPROVED") {
      try {
        const url = applyServiceUrl;
        AxiosInstance()
          .put(url, data)
          .then(() => {
            message.success("Successfully updated");
            getMarketPlaceData(0, filterData);
          })
          .catch((err) => {
            message.error(err.response.data.message);
          });
      } catch (error) {
        alertError("Unable to process. Please try again later.");
      }
    } else {
      alertError(`Your Profile is ${userMeData.status}. Try again Later`);
    }
  };
  useEffect(() => {
    getMarketPlaceData(0, filterData);
    getUserMe();
    getInsurer();
  }, []);

  useEffect(() => {
    let urlReferralCode = searchParams.get("referralCode") ?? "";
    setValue("referralCode", urlReferralCode);
  }, [setValue, searchParams]);

  const getInsurer = async () => {
    const result = await insurerListController(true);
    setInsurer(result);
  };

  const content = (data) => {
    return (
      <>
        <div className="row text-center ">
          <div className="col">
            {" "}
            <p>Year</p>
          </div>
          <div className="col">
            {" "}
            <p>Value</p>
          </div>
        </div>
        {Object?.entries(data ?? {})?.map((item) => {
          return (
            <div className="row d-flex justify-content-center text-center">
              <div className="col">
                {" "}
                <p className="m-0">{item[0]}</p>
              </div>
              <div className="col">
                {" "}
                <p className="m-0">{Math.round(item[1])}</p>
              </div>
            </div>
          );
        })}
      </>
    );
  };
  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        setUserStatus(resp.data);
        setUserRoles(resp.data.userRoles);
        const temp = resp.data.userRoles;
        const result = temp.filter(function (letter) {
          return letter !== resp.data.currentRole;
        });
        localStorage.setItem("roles", result);
        localStorage.setItem(
          "username",
          resp.data.firstName + " " + resp.data.lastName
        );
      });
  };
  const getMarketPlaceData = (skip, filter) => {
    const url =
      `policy/marketplace/list?take=10&skip=${skip}&isMatured=false&status=APPLIED&portfolioId=${
        portfolioId ?? ""
      }` + obj2url(filter);
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setPaginationMetaData(data.paginationMetaData);
        setDataSource(data.data);
        setPolicies(data.data);
        if (!recommendPolicies) {
          setRecommendPolicies(data.data);
        }
        setLoading(false);
      });
  };
  const policyButtons = (policy, type) => {
    return (
      <Popover
        overlayStyle={{ textAlign: "center" }}
        content={content(policy?.maturityOverview)}
        title="CASH FLOW"
        onClick={() => {
          if (
            userMeData.status === "NOT_UPDATED" ||
            userMeData.status === "REJECTED"
          ) {
            navigate("/investorKyc");
          } else if (userMeData.status === "APPROVED") {
            setApplyServiceUrl(
              `/investor/invest/assignment/${policy.policyId}/${policy.assignments[0].assignmentId}`
            );
            setPartnerCodeModal(true);
            // investNowFunction(policy)
          }
        }}
      >
        <button
          className="investNow"
          onClick={() => {
            if (
              userMeData.status === "NOT_UPDATED" ||
              userMeData.status === "REJECTED"
            ) {
              navigate("/investorKyc");
            } else if (userMeData.status === "APPROVED") {
              setApplyServiceUrl(
                `/investor/invest/assignment/${policy.policyId}/${policy.assignments[0].assignmentId}`
              );
              setPartnerCodeModal(true);
              // investNowFunction(policy)
            }
          }}
        >
          {"Invest Now"}
        </button>
      </Popover>
    );
  };

  const columns = [
    {
      title: "Insurer",
      dataIndex: "insurerLogo",
      key: "insurerLogo",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy.insurer.logo}
          />
        </>
      ),
    },
    // {
    //   title: "Policy Type",
    //   dataIndex: "policy",
    //   key: "policy",
    //   align: "center",
    //   render: (text, policy) => <>{policy.product.productType}</>,
    // },
    // {
    //   title: "Policy Number",
    //   dataIndex: "policy",
    //   key: "policy",
    //   align: "center",
    //   render: (text, policy) => <>{policy.policyNumber}</>,
    // },
    {
      title: "₹ Initial Investment",
      dataIndex: "investmentAmount",
      key: "investmentAmount",
      align: "right",
      render: (text, policy) => <>{amountFormat(text)}</>,
    },
    {
      title: "₹ Total Investment",
      dataIndex: "annualPremium",
      key: "annualPremium",
      align: "right",
      render: (text, policy) => amountFormat(policy.totalInvestmentAmount ?? 0),
    },
    {
      title: "₹ Liquidation Value (Tentative)",
      dataIndex: "liquidationAmount",
      key: "liquidationAmount",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Liquidation Eligible Date",
      dataIndex: "liquidationDate",
      key: "liquidationDate",
      align: "center",
      render: (text, policy) =>
        policy?.liquidationDate
          ? moment(policy?.liquidationDate).format("DD/MM/YYYY")
          : "N/A",
    },

    // {
    //   title: "Investment Tenure",
    //   dataIndex: "investmentTenure",
    //   align: "center",
    //   key: "investmentTenure",
    //   // render: (text, policy) => (

    //   //   <>{moment(policy.maturityDate).diff(moment(), "months")}</>
    //   // ),
    // },
    {
      title: "XIRR",
      dataIndex: "roiPercentage",
      key: "roiPercentage",
      align: "center",
      render: (text, policy) =>
        text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    },

    // {
    //   title: "₹ Future Annual Premium",
    //   dataIndex: "annualPremium",
    //   key: "annualPremium",
    //   align: "right",
    //   render: (text, policy) => <>{amountFormat(text)}</>,
    // },

    // {
    //   title: "Next Premium Due Date",
    //   dataIndex: "premiumDueDate",
    //   key: "premiumDueDate",
    //   align: "center",
    //   render: (text, policy) =>
    //     moment(policy.premiumDueDate).format("DD/MM/YYYY"),
    // },

    {
      title: "Choose Action",
      align: "center",
      dataIndex: "assignmentStatus",
      key: "assignmentStatus",
      render: (text, policy) => (
        <>{policyButtons(policy, "premiumFinanceStatus")}</>
      ),
    },
  ];

  const PolicyCard = ({ policy }) => {
    if (loading) {
      return (
        <>
          {
            <Card
              style={{ width: 300, marginTop: 100, marginRight: 10 }}
              loading={loading}
            />
          }
        </>
      );
    }
    return (
      <>
        <div className="policy-card-marketplace">
          <div className="grid-column-card flex d-flex justify-content-between">
            <div>
              <div className="card-key">Plan Name</div>
              <div className="card-value">{policy.product.productName}</div>
            </div>
            <img
              className="insurer-logo"
              alt="insurerlogo"
              src={policy.insurer.logo}
            />
          </div>
          <div className="grid-column-card">
            <div>
              <div className="card-key">XIRR</div>
              <div className="card-value">
                {parseFloat(policy.roiPercentage).toFixed(1)}
              </div>
            </div>
            <div>
              <div className="card-key">Initial Investment</div>
              <div className="card-value">
                {policy.investmentAmount
                  ? `₹ ${amountFormat(policy.investmentAmount)}`
                  : "-"}
              </div>
            </div>
            <div>
              <div className="card-key">Liquidation Value</div>
              <div className="card-value">
                {amountFormat(policy.liquidationAmount)}
              </div>
            </div>
          </div>
          <div className="flex d-flex justify-content-center">
            <button
              className="investNowPC"
              onClick={() => {
                if (
                  userMeData.status === "NOT_UPDATED" ||
                  userMeData.status === "REJECTED"
                ) {
                  navigate("/investorKyc");
                } else if (userMeData.status === "APPROVED") {
                  setApplyServiceUrl(
                    `/investor/invest/assignment/${policy.policyId}/${policy.assignments[0].assignmentId}`
                  );
                  setPartnerCodeModal(true);
                  // investNowFunction(policy)
                }
              }}
            >
              Invest Now
            </button>
          </div>
          {/* <div className="grid-column-card">
            <button>Invest</button>
          </div> */}
        </div>
      </>
    );
  };
  const LeftArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="left-arrow-icon-marketplace-container arrow-common-container"
        onClick={onClick}
      >
        <ArrowLeftOutlined />
      </div>
    );
  };
  const RightArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="right-arrow-icon-container arrow-common-container"
        onClick={onClick}
      >
        <ArrowRightOutlined />
      </div>
    );
  };
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const settings = {
    infinite: true,
    centerPadding: isMobile ? "10px" : "160px",
    slidesToShow: isMobile ? 1 : isTabletOrMobile ? 1.5 : 4,
    swipeToSlide: true,
    speed: 300,
    rows: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,

    arrows: true,
    // nextArrow: <RightArrow />,
    // prevArrow: <LeftArrow />,
  };

  const change = (data) => {
    getMarketPlaceData((data - 1) * 10, filterData);
  };

  return (
    <section className="tre_bg-gray position-relative">
      {contextHolder}
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />
      <div className="container">
        <div className="tre_top-summary tre_Summary overflow-hide  d-flex justify-content-center ">
          {isTabletOrMobile ? null : (
            <img alt="policy center" height={170} src={policyCenterImage}></img>
          )}
        </div>
      </div>
      <div className="container market-top-container">
        <button
          className="go-portfolio mb-4"
          onClick={() => {
            // insurerListController();
            navigate("/investorDashboard");
          }}
        >
          {" "}
          <i class="fa-solid fa-chevron-left tre_flex-hcenter text-white back-icon "></i>{" "}
          My Portfolio
        </button>
        <Slider className="pt-1 pb-0" {...settings}>
          {recommendPolicies &&
            recommendPolicies.map((object, i) => (
              <PolicyCard key={i} policy={object} />
            ))}
        </Slider>

        <div className="policies-table">
          <div className="table mb-0 marketplace-filter d-flex justify-content-between">
            <div className="col">
              <h5 className="">Investment Options</h5>
              {/* <p className="subhead-filter">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.{" "}
              </p> */}
            </div>
            <div className="col-5 select-container">
              {/* <div className="filter-item custom-select">
                <Controller
                  className="filter-item"
                  name="insurerId"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      // className={`${
                      //   errors.accountType ? "is-invalid" : ""
                      // }`}
                      // value={getValues("accountType")}
                      placeholder="Insurer"
                      onChange={(value) => {
                        updateFilter({ insurerId: value });
                      }}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {insurer.map((item) => (
                        <Option key={item.insurerId} value={item.insurerId}>
                          {item.name}
                        </Option>
                      ))}{" "}
                    </Select>
                  )}
                />
              </div> */}

              <div className="filter-item custom-select ">
                <Controller
                  className="filter-item"
                  name="accountType"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      className="p-0"
                      // className={`${
                      //   errors.accountType ? "is-invalid" : ""
                      // }`}
                      // value={getValues("accountType")}
                      placeholder="Inv. Amount"
                      onChange={(value) => {
                        updateFilter(JSON.parse(value).data);
                      }}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {getAmountFilterType()}
                    </Select>
                  )}
                />
              </div>
              {/* <div className="filter-item">
                <Controller
                  className="filter-item"
                  name="accountType"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      // className={`${
                      //   errors.accountType ? "is-invalid" : ""
                      // }`}
                      // value={getValues("accountType")}
                      placeholder="Type"
                      onChange={(value) => {
                        updateFilter(JSON.parse(value).data);
                      }}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {getProductFilterType()}
                    </Select>
                  )}
                />
              </div> */}
              <div className="filter-item custom-select">
                <Controller
                  className="filter-item"
                  name="year"
                  control={control}
                  errors={errors}
                  render={(props) => (
                    <Select
                      className="p-0"
                      // className={`${
                      //   errors.accountType ? "is-invalid" : ""
                      // }`}
                      // value={getValues("accountType")}
                      placeholder="Inv. Tenure"
                      onChange={(value) => {
                        updateFilter(JSON.parse(value).data);
                      }}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {getYearFilterType()}
                    </Select>
                  )}
                />
              </div>
            </div>
          </div>
          <Table
            bordered={true}
            scroll={{ x: 400 }}
            loading={loading}
            // className="table"
            dataSource={[...dataSource]}
            columns={columns}
            pagination={{
              pageSize: 10,
              total: paginationMetaData.count,
              onChange: change,
            }}
          />
          <div>
            <Modal
              show={partnerCodeModal}
              onHide={() => {
                setPartnerCodeModal(false);
              }}
            >
              <Modal.Header closeButton style={{ alignItems: "start" }}>
                <div>
                  <p>
                    Your investment is subject to approval from Life Insurance
                    Company and includes TPE platform charges.
                  </p>
                  <p className="mb-0">
                    Process will be completed in 4 simple steps
                  </p>
                  <ul>
                    <li>
                      Review &amp; Sign Contract, Assignment / Change of
                      ownership form&nbsp;
                    </li>
                    <li>Approval letter from Life Insurance Company&nbsp;</li>
                    <li>Make Payment</li>
                    <li>
                      Get endorsement letter confirming the change of ownership
                      from Life Insurance Company
                    </li>
                  </ul>
                  <h5 className="mb-0">Enter Partner Code (Optional)</h5>
                </div>
              </Modal.Header>
              <Modal.Body>
                {
                  <form
                    id="partner-code-form"
                    onSubmit={handleSubmit((value) => {
                      // applyServiceApiCall(applyServiceUrl, value);
                      // console.log(value);
                      investNowFunction(value);
                      setPartnerCodeModal(false);
                    })}
                  >
                    {" "}
                    <div className="">
                      {/* Partner Code: (if any) */}
                      <input
                        className="form-control"
                        id="referralCode"
                        type="text"
                        {...register("referralCode")}
                      ></input>
                    </div>
                  </form>
                }
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="normal-button px-3 py-2 "
                  form="partner-code-form"
                  type="submit"
                >
                  Submit
                </button>
                {/* <button
                  className="normal-button px-3 py-2 "
                  form="partner-code-form"
                  type="submit"
                >
                  Submit Without Code
                </button> */}
              </Modal.Footer>
            </Modal>
          </div>
          {userMeData.status === "NOT_UPDATED" && (
            <CompleteProfileModel
              active={active}
              setActive={setActive}
              target={userMeData.currentRole}
            />
          )}
          <RoleSwitch userRoles={userRoles} />
        </div>
      </div>
    </section>
  );
}
